import { DownOutlined } from '@ant-design/icons';
import { Button as BaseButton, Dropdown } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';
import type Template from 'stores/Template';
import { ProcessingStatus } from 'types/ProcessingStatus';

const Button = styled(BaseButton)`
  padding: 0 10px;
`;

function NewDropdown() {
  const store_creative = store.creative;
  const templates = store_creative?.templates;
  const adsManager = store_creative?.ads;

  const newFromTemplate = (template: Template) =>
    adsManager?.newFromTemplate(template);

  const menuItems = (templates?.all || []).map((t) => ({
    label: t.data.name,
    key: t.id,
    // Only a complete template can be used, matching CreativeTemplate.isReady
    // on the backend. ERROR is terminal but not usable, so this is not
    // isTerminalProcessingStatus.
    disabled: t.data.status !== ProcessingStatus.COMPLETE,
    onClick: () => void newFromTemplate(t),
  }));

  const hasReadyTemplates = menuItems.some((i) => !i.disabled);

  return (
    <Dropdown
      disabled={!hasReadyTemplates}
      trigger={['click']}
      menu={{ items: menuItems }}
    >
      <Button>
        <DownOutlined />
        New
      </Button>
    </Dropdown>
  );
}

export default observer(NewDropdown);
